import { fork } from 'redux-saga/effects';
import watchPackagesListener from './packagesSaga';
import watchChannelCategoriesListener from './channelsSaga';

export default function* startForman() {
  yield fork(watchPackagesListener);
  yield fork(watchChannelCategoriesListener);
}



// WEBPACK FOOTER //
// ./src/sagas/index.js